module.exports = __webpack_public_path__ + "static/media/noteable_logo.7e7f8dd0.svg";